<template>
    <div class="modal fade" v-bind:id="modalName" tabindex="-1" role="dialog" aria-labelledby="confirmPopupModalLabel" style="background-color: #000000db;">
        <div class="modal-dialog modal-sm" role="document">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="row">
                        <div class="question">
                            {{question}}
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="modal-footer-container">
                        <button class="modal-button modal-red-button" @click="cancelClicked">CANCEL</button>
                        <button class="modal-button modal-green-button" @click="okClicked">OK</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "confirm-popup-modal",
        props: {
            modalName: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                question: null
            }
        },
        methods: {
            showModal(question) {
                this.question = question;
                $("#" + this.modalName).modal('show');
            },
            hideModal() {
                $("#" + this.modalName).modal('hide');
            },
            okClicked() {
                this.$emit("okClicked", {})
            },
            cancelClicked() {
                $("#" + this.modalName).modal('hide');
            }
        },
        mounted() {
            $("#" + this.modalName).modal({show: false});
        }
    }
</script>

<style scoped>

    .question {
        background-color: transparent;
        color: rgba(0, 255, 169, 1);
        font-family: 'Digital-Serial-Regular';
        font-size: 1em;
        text-align: center;
        border: none;
        width: 100%;
    }

</style>



// WEBPACK FOOTER //
// src/components/modals/ConfirmPopupModal.vue